








































































































import Vue from 'vue';
import ChevronDown from '@/assets/img/icons/chevron-down.svg';
import Footer from '@/vue-components/nav/Footer.vue';

export default Vue.extend({
  name: 'Home',
  components: {
    ChevronDown,
    Footer,
  },
  computed: {
    title(): string {
      return 'Sparkello';
    },
  },
});
